<style scoped lang="scss">
._formList /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 28px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 545px;
}
</style>
<template>
  <div style="display: inline;">
    <template>
      <div style="margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
        {{ $t('rukudantouxinxi') }}
      </div>
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
        <el-form-item class="noborder" :label="$t('gongyingshangmingcheng')">
          <el-input disabled v-model="$attrs.check.supplier == null ? '' : $attrs.check.supplier.name"></el-input>

        </el-form-item>
        <el-form-item class="noborder" :label="$t('danjuleixing')" required>
          <el-select disabled v-model="$attrs.check.type" @change="$forceUpdate()">
            <el-option :label="$t('caigouruku')" :value="0"></el-option>
          </el-select>
        </el-form-item>
        </br>
        <el-form-item class="noborder" :label="$t('danjuriqi')" required>
          <el-date-picker
              v-model="$attrs.check.billDate"
              type="date"
              value-format="timestamp"
              format="yyyy-MM-dd"
              disabled
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="noborder" :label="$t('beizhu')">
          <el-input disabled v-model="$attrs.check.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
    </template>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('rukumingxi')" name="first">
        <div style="height: 600px;">
          <inorder_detail_table v-bind="$attrs"></inorder_detail_table>

        </div>
      
      </el-tab-pane>
      <el-tab-pane :label="$t('fujianxinxi')" name="second">
        <!-- 上传文件 -->
        <appendix v-bind="$attrs" :appendix="$attrs.check" :action="'chakan'"></appendix>
      </el-tab-pane>
      <!-- table表格 -->
    </el-tabs>
    

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'ruku'">
        <div class="dialog-scroller">
          <!--          {{$attrs.check.materialId}}-->
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('wuliaobianma/mingcheng')">
              <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'"
                :ids.sync="yt.editObj.materialId">
              </yi_cross_select>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('wuliaopicihao')">
              <el-input disabled v-model="yt.editObj.materialBatchNo"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('danwei')">
              <!--              <span>{{$attrs.check}}</span>-->
              <el-input disabled v-model="store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][yt.editObj.unit]"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('rukushuliang')">
              <el-input disabled v-model="yt.editObj.quantity"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('weishoushuliang')">
              <el-input disabled v-model="yt.editObj.dueQuantity"></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencishishou')" required>
              <el-input-number v-model="yt.editObj.newReceiveQuantity" :min="0" :max="yt.editObj.quantity"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('cangku/kuqu/kuwei')" required>
              <yi_data_select class="_formList" :key="'1'" :showAllLevels="true" :multiple="false" :max="1"
                :checkStrictly="true" :warehouseLevel="2" :type="'warehouse'"
                :idsPathParent.sync="yt.editObj.idsPathParent" :ids.sync="yt.editObj.warehouseId">
              </yi_data_select>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading"
            @click="yt.req('POST', '/web/in/order/detail/putIn', beforeRuku)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('chouyangleixing')" required>
              <el-select v-model="yt.editObj.samplingType" clearable @change="$forceUpdate()">
                <el-option :label="$t('chouyangfangan')" :value="1"></el-option>
                <el-option :label="$t('100%chouyang')" :value="2"></el-option>
                <el-option :label="$t('gudingchouyang')" :value="3"></el-option>
                <el-option :label="$t('anbaifenbichouyang')" :value="4"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="yt.editObj.samplingType == 1">
              <el-form-item class="noborder" :label="$t('chouyangguochengbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangfanganbianma')" required>
                <el-select filterable :clearable="true" v-model="yt.editObj.samplingPlanId">
                  <el-option v-for="(item, index) in planCodeList" :key="index" :label="item.code"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('yangedu')" required>
                <el-select v-model="yt.editObj.level" clearable>
                  <el-option :label="$t('zhengchang')" :value="1"></el-option>
                  <el-option :label="$t('fangkuan')" :value="2"></el-option>
                  <el-option :label="$t('jiayan')" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('AQL')" required>
                <el-input v-model="yt.editObj.aql"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" clearable @change="$forceUpdate()">
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template
              v-if="yt.editObj.samplingType == 3 || yt.editObj.samplingType == 2 || yt.editObj.samplingType == 4">
              <el-form-item class="noborder" :label="$t('chouyangguochengbianma')" required>
                <el-input disabled v-model="yt.editObj.code"></el-input>
              </el-form-item>
              <el-form-item :label="$t('chouyangguochengmiaoshu')" required>
                <el-input v-model="yt.editObj.desc"></el-input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshu')" required>
                <el-input v-model="yt.editObj.num"></el-input>
              </el-form-item>
              <el-form-item :label="$t('AC')" required>
                <el-input v-model="yt.editObj.ac"></el-input>
              </el-form-item>
              <el-form-item :label="$t('RE')" required>
                <el-input v-model="yt.editObj.re"></el-input>
              </el-form-item>
              <el-form-item :label="$t('shifouqiyong')" required>
                <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()" clearable>
                  <el-option :label="$t('shi')" :value="true"></el-option>
                  <el-option :label="$t('fou')" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading"
            @click="yt.req('POST', '/web/quality/sampling/procedure/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import appendix from "@@/pages/web/wms/purchase_receipt/appendix";
import inorder_detail_table from "@@/pages/web/wms/purchase_receipt/check/rukudanmingxi";
export default {
  name: 'web_wms_purchase_receipt_check_list',
  components: {
    appendix,
    inorder_detail_table
  },
  data() {
    return {
      activeName: 'first',
      options: null,
      warehouseAreaIdDisabled: true,
      warehouseLocationIdDisabled: true,
      planCodeList: [],
      warehouseId: null,
      areaId: null,
      show: false,
      exceptionTypeList: [],
      isShowAreaCode: true,
      isShowLocation: true,
      columns: [{
        label: 'wuliaobianmamingcheng',
        // prop: 'material.name',
        type: 'slot',
        // width: 180,
      }, {
        label: 'wuliaopicihao',
        prop: 'materialBatchNo',
        width: 130,
      }, {
        label: 'danwei',
        prop: 'unit',
        type: 'slot',
        width: 130,
      }, {
        label: 'rukushuliang',
        prop: 'quantity',
        width: 130,
      }, {
        label: 'mingxizhuangtai',
        prop: 'status',
        type: 'slot',
        width: 130,
      }, {
        label: 'shishoushuliang',
        prop: 'actualQuantity',
        width: 130,
      },
      {
        label: 'beizhu',
        prop: 'remark',
        width: 180,
      },

      {
        label: 'caozuo',
        type: 'slot',
        width: 150,
        fixed: 'right'
      }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        inOrderId: this.$attrs.check.id,
      }
      this.yt.get(1);
    }, 300)

    console.log("this.$attrs.check", this.$attrs.check)
  },
  watch: {
    'isShowAreaCode': {
      handler(n) {
        if (n == false) {
          console.log('hhhhhhhhhhhhhhh', n)
          this.warehouseAreaIdDisabled = false
        }
      },
      immediate: false,
      deep: true
    },
    'isShowLocation': {
      handler(n) {
        if (n == false) {
          console.log('hhhhhhhhhhhhhhh', n)
          this.warehouseLocationIdDisabled = false
        }
      },
      immediate: false,
      deep: true
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getItems(checks) {
      this.warehouseId = checks.id
      console.log('check', checks)

      //重置第二个选择框
      this.isShowAreaCode = false
      this.yt.editObj.warehouseAreaId = null
      this.$nextTick(() => {
        this.isShowAreaCode = true
      })


    },
    getItem(checks) {
      // isShowLocation
      this.areaId = checks.id
      console.log('checkqq', checks)
      this.isShowLocation = false
      this.yt.editObj.warehouseLocationId = null
      this.$nextTick(() => {
        this.isShowLocation = true
      })
    },
    setDefaultValue() {
      this.yt.editObj.samplingType = 1;
      this.yt.editObj.enabled = true
    },
    beforeRuku(params) {
      console.log('params111222', params.idsPathParent)
      params.warehouseId = params.idsPathParent[0] ? params.idsPathParent[0] : null
      params.warehouseAreaId = params.idsPathParent[1] ? params.idsPathParent[1] : null
      params.warehouseLocationId = params.idsPathParent[2] ? params.idsPathParent[2] : null
      console.log('params111222', params)
      return params

    },
    beforShowRukuEditDialog(editObj) {

        if (!this.utils.checkPower('web_wms_ware_house_auto_full')) {
          //非客制化用户，不执行该逻辑
          return editObj;
        }
        editObj.newReceiveQuantity = editObj.quantity
        this.http.get('/web/material/warehouse/getLatestOne', {params:{materialId: editObj.material.id}}).then(res => {

          if (!res.data) {
            return;
          }
          if(res.data.warehouseLocationId){
            this.$set(this.yt.editObj, 'warehouseId', parseInt('3'+res.data.warehouseLocationId));
            return
          }
          if(res.data.warehouseAreaId){
            this.$set(this.yt.editObj, 'warehouseId', parseInt('2'+res.data.warehouseAreaId));
            return
          }
          if(res.data.warehouseId){
            this.$set(this.yt.editObj, 'warehouseId', parseInt('1'+res.data.warehouseId));
            return
          }
        }).catch(error=>{
          this.$message.error(error)
        })
        return editObj
      },
  }
};
</script>
